import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
  static values = {
    rows: { type: Number, default: 1 }
  }

  connect() {
    const rows = this.rowsValue
    const gridConfig = rows > 1 ? { rows: rows, fill: 'row' } : undefined

    this.swiper = new Swiper(this.element, {
      direction: 'horizontal',
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: true,
      speed: 7000,
      centerInsufficientSlides: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 10,
        }
      }
    });
  }
}
